import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useColorMode } from '../../contexts/ColorModeContext';
import { BRAND } from '../../styles/ui';

const ColorModeToggle: React.FC = () => {
  const { mode, toggleMode } = useColorMode();
  const label = mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <Tooltip title={label}>
      <IconButton onClick={toggleMode} aria-label={label} sx={{ color: BRAND.muted, '&:hover': { color: BRAND.ink, backgroundColor: BRAND.hover } }}>
        {mode === 'dark' ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ColorModeToggle;
